export enum TipoBoton {
  CORREO,
  FIRMAR,
  ESCANEAR,
  VER,
  REGENERAR,
  CINCEL,
  AUDITORIA,
  FIRMAR_ONLINE
}

export enum FlujoDocumento {
  NINGUNO = "NINGUNO",
  GENERAR = "GENERAR",
  ESCANEAR = "ESCANEAR",
  FIRMA_MATERIAL = "FIRMA_MATERIAL",
  FIRMA_DIGITAL = "FIRMA_DIGITAL",
  CINCEL = "CINCEL"
}

export enum TipoDocumento {
  PROPIETARIO = "PROPIETARIO",
  TITULAR = "TITULAR",
  INTEGRANTE = "INTEGRANTE",
  EXTERNO = "EXTERNO",
  INVITADO = "INVITADO",
  INVITADO_ESPECIAL = "INVITADO_ESPECIAL"
}

export enum StatusAutorizacion {
  NO_GENERADO = "NO_GENERADO",
  NO_AUTORIZADO = "NO_AUTORIZADO",
  AUTORIZADO = "AUTORIZADO",
  FIRMA_INVALIDA = "FIRMA_INVALIDA",
  DOCUMENTO_INCORRECTO = "DOCUMENTO_INCORRECTO"
}

export interface Expediente {
  idExpediente: number;
  idMembresiaSocio: number;
  completo: boolean;
  autorizado: boolean;
  activo: boolean;
  vigentes: Archivo[];
  items: Archivo[];
}

export interface Archivo {
  idExpediente: number;
  idItem: number;
  storage?: string;
  fechaFirma?: string;
  completo: boolean;
  statusAutorizacion: StatusAutorizacion;
  moduloExpedientes: boolean;
  moduloInvitadosEspeciales: boolean;
  moduloTotalPass: boolean;
  requeridoComision: boolean;

  idDocumento: number;
  codigo: string;
  nombre: string;
  descripcion: string;
  flujo: FlujoDocumento;
  critico: boolean;
  tipo: TipoDocumento;

  idMembresiaSocioPersona?: number;
  idPersona?: number;
  idMedioPago?: number;
  idCotizacionItem?: number;
  idPersonaEvaluacion?: number;

  idOwner: string;
  nombreCompleto: string;
  correo: string;
  migrado: boolean;

  idEntity: number;

  // Cincel
  storageCincelAudit?: string;

  // Datos exclusivos para verificación de extranjeros
  extranjeroVerificado?: boolean;

  // Datos de verificación sobre IA
  verificacionExtranjero?: {
    resolucion?: boolean;
    razonamiento?: string;
    porcentajeAceptacion?: number;
    nombreCoincide?: boolean;
    fechaNacimientoCoincide?: boolean;
    esPasaporte?: boolean;
    esCarnetExtranjeria?: boolean;
    documentoManipulado?: boolean;
  };
  verificacionLegibilidad?: {
    esLegible?: boolean;
    razonamiento?: string;
    porcentajeCalidad?: number;
    errorDesenfoque?: boolean;
    errorIluminacion?: boolean;
    errorOrientacion?: boolean;
  };
  verificacionIdentificacion?: {
    resolucion?: boolean;
    razonamiento?: string;
    porcentajeAceptacion?: number;
    nombreCoincide?: boolean;
    fechaNacimientoCoincide?: boolean;
  };

  // Encuestas DAC que justifican la autorización médica
  encuestas?: AutorizacionMedicaEncuesta[];
}

export interface AutorizacionMedicaEncuesta {
  idExpediente: number;
  idPersonaEvaluacion: number;
  idItem: number;
  fechaRespuesta: string;
  respuestasAfirmativas: RespuestaAfirmativaDAC[];
}

export interface RespuestaAfirmativaDAC {
  idPregunta: number;
  pregunta: string;
}

export interface ArchivoHistorico {
  idExpediente: number;
  idItem: number;
  statusAutorizacion: StatusAutorizacion;
  completo: boolean;
  storage: string;

  idDocumento: number;
  codigo: string;
  nombre: string;

  idResponsable: number;
  responsableNombre: string;
  responsableNumeroEmpleado: string;
  fechaCreacion: string;
}

export interface ArchivoId {
  idExpediente: number;
  idItem: number;
}

export interface ArchivoFirma {
  idExpediente: number;
  idItem: number;
  bookmark: string;
  nombre: string;
  base64Uri: string;
}

export interface RequestArchivo {
  codigo: string;
  idMembresiaSocio?: number;
  idPersonaExpediente?: number;
  idMembresiaSocioPersona?: number;
  idPersonaDocumento?: number;
  idMedioPago?: number;
  idCotizacionItem?: number;
  idPersonaEvaluacion?: number;
  values?: any;
}

export interface CreateDocumentLinkRequest {
  idExpediente: number;
  idItem: number;
  idPersona: number;
  firmanteUuid: string;
  documentoUuid: string;
  curp: string;
  email: string;
  nombre: string;
  resend?: boolean;
}
